/**
 * AWS Amplify configuration
 * Reads from environment variables set in .env.local
 */

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

// Validate required config at startup
const requiredVars = [
  'REACT_APP_USER_POOL_ID',
  'REACT_APP_USER_POOL_CLIENT_ID',
];

const missingVars = requiredVars.filter((varName) => !process.env[varName]);

if (missingVars.length > 0 && process.env.NODE_ENV === 'development') {
  console.warn(
    `Missing required environment variables: ${missingVars.join(', ')}. ` +
    'Copy .env.example to .env.local and fill in the values from terraform output.'
  );
}

export default awsConfig;
